import { render, staticRenderFns } from "./ProfileDownloads.vue?vue&type=template&id=7831fc61"
import script from "./ProfileDownloads.vue?vue&type=script&lang=js"
export * from "./ProfileDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports